import type {ColorFillPropertyType} from '@Components/color-fill';
import type {ColorStorage} from '@Components/color-picker-v2';

/** Shown in the type dropdown selector when the selected items disagree on fill type (solid vs gradient). */
export const MIXED_TYPE_PLACEHOLDER = '--';

export interface ColorOptionTypeSectionProps {
  className?: string;
  color: ColorStorage[];
  type: ColorFillPropertyType;

  onChangeType: (type: ColorFillPropertyType) => void;

  onChangeSelectedColor: (id: string) => void;

  isGradientEnabled?: boolean;
  /** When true the type dropdown row is hidden entirely (e.g. a context that only edits a solid colour). */
  hideTypeSelector?: boolean;
  selectedColorId: string;
  /** When true, the solid colour swatch shows the "mixed colours" thumbnail (a multi-selection whose colours differ). Gradient swatches are unaffected. */
  isColorMixed?: boolean;
  /** When true the items disagree on fill type: the dropdown shows `--` and the panel collapses to a single colour row. */
  isTypeMixed?: boolean;
}

export interface ColorTypeDropdownOptions {
  text: string;
  type: ColorFillPropertyType;
  id: string;
}
